import styled from 'styled-components';
import { DotFill } from '@styled-icons/octicons/DotFill';

const height = '25px';
const width = '25px';

export const Nutral = styled(DotFill)`
height: ${height};
width: ${width};
color:#cccccc;
// margin-right: 10px;
`;

export const RedDot = styled(DotFill)`
height: ${height};
width: ${width};
color:#EB5757;
// margin-right: 10px;
`;

export const OrangeDot = styled(DotFill)`
height: ${height};
width: ${width};
color:#F2C94C;
// margin-right: 10px;
`;

export const GreenDot = styled(DotFill)`
height: ${height};
width: ${width};
color: #219653;
// margin-right: 10px;
`;